import { IntlProvider as BaseIntlProvider } from "react-intl";
import { DEFAULT_LOCALE } from "@/utils/intl";

export default function IntlProvider({ children }: React.PropsWithChildren) {
  return (
    <BaseIntlProvider locale={DEFAULT_LOCALE}>{children}</BaseIntlProvider>
  );
}
